<template>

    <div class="ec-unidades">
        <div class="ec-unidades__cabecalho">
            <h3>Escolha uma unidade</h3>
            <p>Selecione a unidade que deseja administrar.</p>
        </div>

        <div class="ec-unidades__grade">
            <a v-for="unidade_empresa, key in empresasUnidades.data" :key="key" class="ec-unidade" :href="'/Access/Unity/Unitie/'+unidade_empresa.id">
                <span class="ec-unidade__icone"><i class="fa-solid fa-building-columns"></i></span>
                <span class="ec-unidade__texto">
                    <span class="ec-unidade__nome">{{ quebraTextoIfen(unidade_empresa.nomecompleto) }}</span>
                    <span class="ec-unidade__codigo">{{ unidade_empresa.companies.codigoempresa }} - {{ unidade_empresa.codigounidade }}</span>
                </span>
                <i class="fa-solid fa-chevron-right ec-unidade__seta"></i>
            </a>
        </div>

        <paginate class="padding text-center">
            <li v-for=" link, key in empresasUnidades.links" :key="key" :class="(link.active ? 'page-item active':(link.url ? 'page-item':'page-item disabled'))" style="cursor:pointer;">
                <a class="page-link" tabindex="-1" v-html="link.label" @click="paginacao(link)"></a>
            </li>
        </paginate>
        <loading :id="'GetUnidades'" titulo="Obtendo lista de Unidades, Aguarde..." :sem-padding="true" gif-carregando="/imagens/carregando.gif"></loading>
      </div>

</template>

<script>
export default {
    props:{
        // empresasUnidades:{
        //     type:Object,
        //     required:true
        // }
        urlUnities:{type:String,required:true},
        
    },
    data(){
        return{
            empresasUnidades:{
                type:Object,
                required:true
            },
            //urlUnidades:window.location.origin+'/api/v1'+this.urlUnities,
        }
    },
    methods:{
        quebraTextoIfen(texto){
            let array = texto.split('-');
            let concatenar = '';
            
            if(array.length>0){
                //window.alert(array.length)
                for(let i=0;i<array.length;i++){
                    
                    if(i==0){
                        
                        let arrayAux = array[i].trim().split(' ');
                        
                        // console.log('arrayAux',arrayAux);
    
                        if(arrayAux.length>0){
    
                            for(let j=0; j<arrayAux.length; j++){
    
                                if(j<(arrayAux.length-1)){
                                    concatenar = concatenar + arrayAux[j].substr(0,1).trim() 
                                }else{
                                    concatenar = concatenar + arrayAux[j].substr(0,1).trim()+' - '
                                }
    
                            }
    
                        }

                    }else{
                        concatenar = concatenar + array[i].trim()
                    }


                }
            }else{
                concatenar = texto
            }
            
            return concatenar
        },
        paginacao(link){
            if(link.url){
                this.urlUnidades = link.url; // ajustando a url com parâmetros de pagina
                //  console.log(this.urlUnidades)
                this.getUnities();
                console.log(link.url)
            }

        },
        getUnities(){
            // Client/ClientUser
            //gera configurações de cabeçalho para requisição
            console.log('URL: ' + this.urlUnidades)
            $('#GetUnidades').modal('show');
            var config = {
                method: 'get',
                url: this.urlUnidades,
                // headers: {
                //         'Accept': 'application/json',
                //         'Authorization': this.$root.token(),
                //     },
                };
                //executa requisição
                axios(config)
                .then(response => {
                     console.log(response.data.Pessoas)
                    this.empresasUnidades = response.data.Pessoas
                    $('#GetUnidades').modal('hide');
                })
                .catch(function (error) {
                    console.log(error);
                    $('#GetUnidades').modal('hide');
                });
                console.log(window.location.origin+'/api/v1'+this.urlUnities)
            },
    },
    created(){
        this.urlUnidades=window.location.origin+'/api/v1'+this.urlUnities+'/All',
        this.getUnities();
    }
}
</script>

<style scoped>
    .ec-unidades{
        padding: 1rem .5rem .25rem;
        animation: fadein .35s ease;
    }

    .ec-unidades__cabecalho{
        text-align: center;
        margin-bottom: 1.25rem;
    }

    .ec-unidades__cabecalho h3{
        margin: 0;
        font-size: 1.25rem;
        font-weight: 800;
        color: #1f2d33;
    }

    .ec-unidades__cabecalho p{
        margin: .25rem 0 0;
        font-size: .85rem;
        color: #64767c;
    }

    .ec-unidades__grade{
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: .75rem;
        margin-bottom: 1rem;
    }

    .ec-unidade{
        display: flex;
        align-items: center;
        gap: .75rem;
        padding: .85rem 1rem;
        text-align: left;
        text-decoration: none;
        color: #1f2d33;
        background: #fff;
        border: 1px solid #e3e9ed;
        border-radius: .75rem;
        box-shadow: 0 1px 2px rgba(16, 42, 49, .06);
        transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
    }

    .ec-unidade:hover{
        transform: translateY(-2px);
        border-color: #1a7580;
        box-shadow: 0 6px 18px rgba(16, 42, 49, .12);
        text-decoration: none;
        color: #1f2d33;
    }

    .ec-unidade__icone{
        width: 40px;
        height: 40px;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 10px;
        color: #1c4d5a;
        background: rgba(26, 117, 128, .1);
        transition: background-color .15s ease, color .15s ease;
    }

    .ec-unidade:hover .ec-unidade__icone{
        color: #fff;
        background: linear-gradient(135deg, #1a7580, #1c4d5a);
    }

    .ec-unidade__texto{
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
    }

    .ec-unidade__nome{
        font-size: .85rem;
        font-weight: 700;
        line-height: 1.3;
    }

    .ec-unidade__codigo{
        font-size: .72rem;
        font-weight: 600;
        color: #64767c;
    }

    .ec-unidade__seta{
        font-size: .7rem;
        color: #a3b3b8;
        transition: transform .15s ease, color .15s ease;
    }

    .ec-unidade:hover .ec-unidade__seta{
        color: #1a7580;
        transform: translateX(2px);
    }
</style>